import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/header_logo_small.png'


const _hoisted_1 = {
  id: "header",
  class: "au-header"
}
const _hoisted_2 = {
  class: "navbar navbar-expand-lg au-nav",
  "aria-label": "Hlavná navigácia"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "mainNav"
}
const _hoisted_5 = { class: "navbar-nav mx-lg-auto align-items-lg-center" }
const _hoisted_6 = ["id"]
const _hoisted_7 = ["aria-labelledby"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = {
  class: "dropdown-menu",
  "aria-labelledby": "dd-vseobecne"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "d-flex align-items-center gap-2 mt-3 mt-lg-0" }
const _hoisted_13 = {
  key: 0,
  class: "au-admin-links d-flex align-items-center"
}

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useContentsStore } from "@/store/contents-store";
import { Content } from "@/types/content-types";
import { scrollToId } from "@/utils/scroll";


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const store = useContentsStore();
const { contents, categories, logged } = storeToRefs(store);

const generalLinks = [
  { id: "gallery-section", label: "Galéria" },
  { id: "faq-section", label: "Otázky" },
  { id: "formular", label: "Napíšte nám" },
  { id: "dokumenty", label: "Dokumenty" },
  { id: "cennik-sluzieb", label: "Cenník" },
  { id: "mapa", label: "Lokalita" },
  { id: "telefony", label: "Kontakt" },
];

function categoryContents(categoryId: number): Content[] {
  return contents.value.filter((c) => c.category === categoryId);
}

// Only categories that actually contain something are worth showing in the nav.
const visibleCategories = computed(() =>
  categories.value.filter((c) => categoryContents(c.id as number).length)
);

/**
 * Collapses the mobile menu (uses Bootstrap's own toggler, so no extra JS API needed).
 * Returns true when a menu was actually open.
 */
function closeMenu(): boolean {
  const nav = document.getElementById("mainNav");
  if (nav?.classList.contains("show")) {
    document.querySelector<HTMLElement>(".navbar-toggler")?.click();
    return true;
  }
  return false;
}

async function go(id: string) {
  // The sticky header shrinks while the menu collapses; scrolling before that
  // finishes would land in the wrong place, so wait for the animation (~350 ms).
  if (closeMenu()) {
    await new Promise((resolve) => setTimeout(resolve, 400));
  }
  await scrollToId(id);
}

function onBrandClick() {
  closeMenu();
  window.scrollTo({ top: 0, behavior: "smooth" });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "au-brand",
          to: { name: 'home' },
          onClick: onBrandClick
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", {
              class: "au-brand__mark",
              "aria-hidden": "true"
            }, [
              _createElementVNode("img", { src: _imports_0 })
            ], -1),
            _createElementVNode("span", { class: "au-brand__text" }, [
              _createElementVNode("span", { class: "au-brand__name" }, "ZPS Auxilium"),
              _createElementVNode("span", { class: "au-brand__tag" }, "služby seniorom")
            ], -1)
          ]))]),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createElementVNode("button", {
          class: "navbar-toggler border-0 shadow-none px-0",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#mainNav",
          "aria-controls": "mainNav",
          "aria-expanded": "false",
          "aria-label": "Otvoriť menu"
        }, [
          _createElementVNode("i", { class: "bi bi-list fs-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCategories.value, (category) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item dropdown",
                key: category.id
              }, [
                _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  href: "#",
                  role: "button",
                  id: `dd-${category.id}`,
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                }, _toDisplayString(category.name), 9, _hoisted_6),
                _createElementVNode("ul", {
                  class: "dropdown-menu",
                  "aria-labelledby": `dd-${category.id}`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryContents(category.id as number), (content) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: content.id || content.href
                    }, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        type: "button",
                        onClick: ($event: any) => (go(content.href as string))
                      }, _toDisplayString(content.link), 9, _hoisted_8)
                    ]))
                  }), 128))
                ], 8, _hoisted_7)
              ]))
            }), 128)),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                class: "nav-link dropdown-toggle",
                href: "#",
                role: "button",
                id: "dd-vseobecne",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, "Všeobecné"),
              _createElementVNode("ul", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(generalLinks, (item) => {
                  return _createElementVNode("li", {
                    key: item.id
                  }, [
                    _createElementVNode("button", {
                      class: "dropdown-item",
                      type: "button",
                      onClick: ($event: any) => (go(item.id))
                    }, _toDisplayString(item.label), 9, _hoisted_11)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_unref(logged))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: { name: 'gallery' },
                    title: "Galéria",
                    onClick: closeMenu
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "bi bi-file-earmark-image" }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: { name: 'mail' },
                    title: "Správy",
                    onClick: closeMenu
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "bi bi-envelope-paper" }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: { name: 'cloud' },
                    title: "Dokumenty",
                    onClick: closeMenu
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "bi bi-file-earmark-text" }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: { name: 'settings' },
                    title: "Nastavenia",
                    onClick: closeMenu
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "bi bi-gear" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _cache[7] || (_cache[7] = _createElementVNode("a", {
              class: "btn btn-primary",
              href: "tel:+421415006029"
            }, [
              _createElementVNode("i", { class: "bi bi-telephone me-2" }),
              _createTextVNode("0918 666 410 ")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})